import API, { config } from "./config";
import { AxiosPromise } from "axios";
import * as UserModule from "./../Modules/UserModule";

export function loginUser(
  username: string,
  password: string,
  facebookFlag: boolean,
  { appleFlag, data }
): AxiosPromise<UserModule.Types.User> {
  console.log("test");

  return API.post(
    "login",
    appleFlag
      ? { ...data, apple: true }
      : { username, password, facebook: facebookFlag }
  );
}

export function logout(): AxiosPromise<UserModule.Types.User> {
  return API.put(
    "logout",
    { refreshToken: localStorage.getItem("refreshToken") },
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}

export function registerUser(
  newUser: UserModule.Types.RegisterUser
): AxiosPromise<any> {
  return API.post("register", newUser);
}

export function editUser(
  newUserData: UserModule.Types.SpecificUser
): AxiosPromise<any> {
  return API.post(
    "user/update",
    newUserData,
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}

export function editUserByAdmin(newUserData: any): AxiosPromise<any> {
  return API.post(
    `users/${newUserData.id}`,
    newUserData,
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}
export function editSalesmanDetails(
  newSalesmanDetails: UserModule.Types.SalesmanDetails
): AxiosPromise<any> {
  return API.post(
    "user/salesmanDetails",
    newSalesmanDetails,
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}

export function getLoggedUserData(): AxiosPromise<any> {
  return API.get(
    "user",
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}

export function getContactsList(customerID, loggedUserID): AxiosPromise<any> {
  return API.get(
    "contactHistory",
    config(
      { customer: customerID, salesman: loggedUserID },
      { "x-auth-token": localStorage.getItem("token") }
    )
  );
}

export function addNewContact(data, customerID): AxiosPromise<any> {
  return API.post(
    "contactHistory",
    { ...data, customer: customerID },
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}

export function resetPassword(userEmail): AxiosPromise<any> {
  return API.post("user/password_reset_query", userEmail);
}

export function resetPasswordContinue(data): AxiosPromise<any> {
  return API.post("user/password_reset", data);
}

export function checkIfUserIsValid(token): AxiosPromise<any> {
  return API.get(
    "user/validate_token",
    config(null, { "x-auth-token": token })
  );
}

export function deleteUser(token) {
  return API.delete("user", config(null, { "x-auth-token": token }));
}

export function deleteUserByAdmin(token, id) {
  return API.delete(`users/${id}`, config(null, { "x-auth-token": token }));
}

export function getUsersList(): AxiosPromise<
  Array<UserModule.Types.UserInList>
> {
  return API.get(
    "users",
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}

export function getSmsHistory(): AxiosPromise<
  Array<UserModule.Types.SmsHistory>
> {
  return API.get(
    "sms/history",
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}

export function sendSmsToUsers(data): AxiosPromise<any> {
  return API.post("sms/send", data);
}

export function getSpecificUser(
  id
): AxiosPromise<UserModule.Types.SpecificUser> {
  return API.get(
    `users/${id}`,
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}

export function registerSalesman(data): AxiosPromise<any> {
  return API.post("register/salesman", data);
}

export function getTreeStructure(): AxiosPromise<any> {
  return API.get(
    `user/tree`,
    config(null, { "x-auth-token": localStorage.getItem("token") })
  );
}



// WEBPACK FOOTER //
// ./src/Connectors/UserConnector.ts